// extracted by mini-css-extract-plugin
module.exports = {"modalitem":"_3iW3cd2BJqfQ_4BELTAdOA"};